import { EI18nLanguageUI, useTranslation } from '@packages/utils';

const useGetFormData = () => {
  const { t } = useTranslation({ lng: 'translate' });

  const chooseLanguageData = {
    userLanguage: {
      name: 'userLanguage',
      label: '',
      options: [
        {
          value: EI18nLanguageUI.ENGLISH,
          label: t('enums.language.ENGLISH', {
            lng: EI18nLanguageUI.ENGLISH,
          }),
        },
        {
          value: EI18nLanguageUI.SPANISH,
          label: t('enums.language.SPANISH', {
            lng: EI18nLanguageUI.SPANISH,
          }),
        },
      ],
      initialValue: EI18nLanguageUI.ENGLISH,
    },
  };
  return { chooseLanguageData };
};

export default useGetFormData;
